import * as React from 'react';
import glamorous from 'glamorous';
import { Query } from 'react-apollo';
import { RvLoader } from '../../components/Loader';
import gql from 'graphql-tag';
import { formatNumber, GetSuggestedMax, formatPeriod, formatPeriodNoSpace, convertStringNumberToNumber } from '../../helpers/ChartHelper';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { ChartCommonProps, IconButtonWrapper, ChartCommonState } from '../Common';
import { WithStyles, withStyles, TextField, IconButton } from '@material-ui/core';
import { styles } from '../styles';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Scale,
    Tick,
    Chart,
    ChartEvent,
    ActiveElement,
} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { WithTranslation, withTranslation } from 'react-i18next';
import { TranslationTextList } from '../../locales/common';
import { HelpWrapper } from '../../home/Common';
import { ChartInfo } from '../../components/ChartInfo';
import { ChartFilter } from '../../home/ChartComponents';

import { RV_CHART_CLASS, RV_CHART_COLORS, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../../home/chartTheme';
import { ChartHeading } from '../../home/ChartHeading';
import { ChartLimitNote } from '../../home/ChartLimitNote';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../../home/AnimatedNumber';
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    zoomPlugin
);

// tslint:disable-next-line:no-any
const CardWrapper = glamorous.div<{ theme?: any }>(props => ({
    // padding: 15,
    display: 'flex',
    flexFlow: 'column',
    textAlign: 'center',
    // fontSize: '18px',
    height: '100%',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 0 14px 0 rgba(81,115,255,0.09)',
    width: '100%',
    '@media print': {
        alignItems: 'center',
    }
}));

const BarWrapper = glamorous.div<{ theme?: object }>((props) => ({
    position: 'relative',
    paddingBottom: '10px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
}));

const BarTitleContainer = glamorous.div<{ theme?: object }>((props) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '15px 15px 0px 15px',
    fontSize: '16px',
    fontWeight: 600,
    [`& .${`h1`}`]: {

    },
    [`& .${`h2`}`]: {
        fontSize: '2.5rem',
        padding: '10px 0',
    },
    [`& .${`h3`}`]: {
        paddingTop: '10px'
    },
    '& .increase': {
        color: 'green',
    },
    '& .decrease': {
        color: 'red',
    }
})).withProps({ className: 'rv-chart-title-area' });

const BarContainer = glamorous.div<{ theme?: object }>((props) => ({
    padding: '5px 15px 15px 15px',
    minHeight: '300px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '350px',
    maxWidth: 'auto',
    position: 'relative',
    '@media (max-width: 533px)': {
        maxWidth: '350px',
        margin: '0 auto',
    },
    [`& .${`titleWrapper`}`]: {
        textAlign: 'center',
        display: 'inline-block',
        width: '100%',
        padding: '15px',
        [`& .${`title`}`]: {
            fontSize: '18px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`value`}`]: {
            fontSize: '24px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`secondary-title`}`]: {
            fontSize: '16px',
            fontWeight: 400,
            display: 'block',
            marginBottom: '15px',
        }
    }
}));

const LoadWrapper = glamorous.div<{ theme?: object }>((props) => ({
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
}));

const ProcessEnquiryWrapper = glamorous.div<{ theme?: object }>((props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    margin: '6px 15px 15px 15px',
    padding: '8px 10px 8px 12px',
    borderRadius: 10,
    backgroundColor: '#f7f8fc',
    fontSize: 12.5,
    color: '#667085',
    '& .MuiTextField-root': {
        width: 76,
    },
    '& .MuiOutlinedInput-input': {
        textAlign: 'center',
        fontWeight: 800,
        color: '#1f2433',
        padding: '6px 4px 6px 10px',
    },
    '& .MuiOutlinedInput-root': {
        backgroundColor: '#fff',
        borderRadius: 8,
    },
}));

export enum LeadConversationEnum {
    All = 'All',
    Lawyer = 'Lawyer',
}

interface ChartProps extends ChartCommonProps, WithStyles<typeof styles>, WithTranslation {
    getSelectedItem?: (searchCriterias: Array<SearchCriteria>, isShowCompleted: boolean, title?: string) => void;
    period: string;
    groupBy: string;
    chartFilter?: ChartFilter;
}

interface ChartState extends ChartCommonState {
    // 
    minimumEnquiries: number;
}

class LeadConversationInLastByPeriodChart extends React.Component<ChartProps, ChartState>  {

    // tslint:disable-next-line: no-any
    public chartRef: React.RefObject<any>;
    private chartFilter: ChartFilter | undefined;

    constructor(props: ChartProps, state: ChartState) {
        super(props, state);
        this.onCloseChart = this.onCloseChart.bind(this);
        this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
        this.handlePopoverClose = this.handlePopoverClose.bind(this);
        this.onHover = this.onHover.bind(this);

        this.onPan = this.onPan.bind(this);

        this.chartRef = React.createRef();

        this.chartFilter = this.props.chartFilter;

        this.state = {
            open: false,
            anchorEl: undefined,
            minimumEnquiries: 10
        };
    }

    public componentDidMount() {
        // 
    }

    public componentWillUnmount() {
        // 
    }

    // tslint:disable-next-line: no-any
    public componentWillReceiveProps(nextProps: Readonly<ChartProps>, nextContext: any): void {
        if (this.props.chartFilter !== nextProps.chartFilter) {
            this.chartFilter = nextProps.chartFilter;
        }
    }

    public render() {

        const { groupBy, period  } = this.props;

        const { t } = this.props as {
            t: (key: keyof TranslationTextList) => string;
        };

        return (
            <CardWrapper>
                {/* tslint:disable-next-line: no-any */}
                <Query<any> 
                    query={ChartData}
                    variables={{                      
                        groupBy: groupBy,
                        entityType: this.chartFilter?.entityType,
                        entityGuid: this.chartFilter?.entityGuid,
                        period: period,
                        minimumEnquiries: this.state.minimumEnquiries
                    }}
                >
                    {({ loading, error, data }) => {

                        if (loading) {
                            return (
                                <ChartSkeleton variant="bars" />
                            );
                        }

                        const statistics = data.statistics;

                        let lead = (loading || error ||
                            statistics === null || statistics === undefined)
                            ? null
                            : statistics.lead;

                        let leadsConversionInLast12Months = lead ? lead.leadsConversionInLastPeriod : null;

                        if (leadsConversionInLast12Months) {

                            const {
                                groupedByCount,
                                leadsPeriodTotalCount,
                                groupedLeadsForLastPeriod
                            } = leadsConversionInLast12Months;

                            const lastPeriodTotalRate = leadsPeriodTotalCount.lastPeriodTotalRate;
                            // tslint:disable-next-line:max-line-length
                            const previousPeriodTotalRate = leadsPeriodTotalCount.previousPeriodTotalRate;
                            // const previousPeriodTotalCount = leadsPeriodTotalCount.previousPeriodTotalCount;
                            const lastPeriodTotalCount = leadsPeriodTotalCount.lastPeriodTotalCount;

                            // tslint:disable-next-line:no-any
                            let groupedBy = groupedLeadsForLastPeriod.map((value: any) => { return value.groupedBy; });

                            let highestValue = 0;
                            // tslint:disable-next-line: no-any
                            let lastPeriodRate = groupedLeadsForLastPeriod.map((value: any) => { 
                                if (highestValue < value.lastPeriodRate) {
                                    highestValue = value.lastPeriodRate;
                                }
                                return value.lastPeriodRate; });
                            // tslint:disable-next-line: no-any
                            let previousPeriodRate = groupedLeadsForLastPeriod.map((value: any) => { 
                                if (highestValue < value.previousPeriodRate) {
                                    highestValue = value.previousPeriodRate;
                                }
                                return value.previousPeriodRate; });  
                            // tslint:disable-next-line: no-any
                            let lastPeriodCount = groupedLeadsForLastPeriod.map((value: any) => { 
                                return value.lastPeriodCount; });
                            // tslint:disable-next-line: no-any
                            let previousPeriodCount = groupedLeadsForLastPeriod.map((value: any) => { 
                                return value.previousPeriodCount; });  

                            return (
                                <BarWrapper className={RV_CHART_CLASS}>
                                    <IconButtonWrapper
                                        aria-label="close"
                                    >
                                        <HelpWrapper className="rv-chart-help">
                                            <ChartInfo 
                                                description={this.props.description}
                                            />
                                        </HelpWrapper>
                                        <IconButton
                                            aria-label="close"
                                            onClick={this.onCloseChart}
                                            size="small"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </IconButtonWrapper>
                                    <BarTitleContainer>
                                        <ChartHeading icon={<InsertChartOutlinedIcon />} title={<>{lastPeriodTotalCount} {t('Enquiries')} Converted in the last {formatPeriod(period)}</>} />
                                        <div className="h2">
                                            <AnimatedNumber value={lastPeriodTotalRate} format={(amount) => formatNumber(amount)} />%
                                        </div>
                                        <div className="h3">
                                            {formatNumber(previousPeriodTotalRate)}% in previous {formatPeriod(period)} to that</div>
                                        <div className="h3 rv-chart-section">{t('Enquiry')} Conversion by {groupBy}</div>
                                    </BarTitleContainer>
                                    <BarContainer className="rv-chart-bars">
                                        <Bar
                                            ref={this.chartRef}
                                            // tslint:disable-next-line: no-any
                                            onClick={(event: React.MouseEvent<any>) => {
                                                const _data = getElementAtEvent(this.chartRef.current, event);
                                                if (_data.length > 0 && this.props.getSelectedItem) {

                                                    // const _index = getElementAtEvent(this.chartRef.current, event)[0].index;

                                                    // const item = groupedBy[_index];

                                                    // const searchCriterias = new Array<SearchCriteria>();

                                                    // searchCriterias.push(
                                                    //     { property: groupBy, operator: 'eq', comparison: item },
                                                    //     //  tslint:disable-next-line: max-line-length
                                                    //     { property: 'InstructionDateStartByPeriod', operator: 'gteq', comparison: Period.toString() },
                                                    //     //  tslint:disable-next-line: max-line-length
                                                    //     { property: 'InstructionDateEndByPeriod', operator: 'lteq', comparison: periodInMonths.toString() }
                                                    // );

                                                    // return this.props.getSelectedItem(
                                                    //     searchCriterias,
                                                    //     false,
                                                    //     // tslint:disable-next-line: max-line-length
                                                    //     `New matters in the last ${periodInMonths} months by ${GetGroupBy(groupBy)}`
                                                    // );
                                                }
                                            }}
                                            data={{
                                                labels: groupedBy,
                                                datasets: [
                                                    {
                                                        label: 'Previous ' + formatPeriod(period),
                                                        ...rvBarDatasetStyle(RV_CHART_COLORS.primarySoft),
                                                        data: previousPeriodRate
                                                    },
                                                    {
                                                        label: 'Current ' + formatPeriod(period),
                                                        ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                                        data: lastPeriodRate
                                                    }
                                                ]
                                            }}
                                            options={{
                                                onHover: this.onHover,
                                                indexAxis: 'y' as const,
                                                animation: rvChartAnimation(),
                                                elements: { bar: { borderWidth: 0 } },
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                scales: {
                                                  x: {
                                                    grid: rvValueAxisStyle.grid,
                                                    // beginAtZero: true,
                                                    suggestedMax: GetSuggestedMax(highestValue) > 100 ? 100 : GetSuggestedMax(highestValue),
                                                    beginAtZero: true,
                                                    ticks: {
                                                        ...rvValueAxisStyle.ticks,
                                                        autoSkip: false,
                                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                                            return `${formatNumber(tickValue)}`;
                                                        }
                                                    }
                                                  },
                                                  y: {
                                                    grid: rvCategoryAxisStyle.grid,
                                                    // min: 0,
                                                    // max: 9 // minimum display
                                                    ticks: {
                                                        ...rvCategoryAxisStyle.ticks,
                                                        autoSkip: false
                                                    }
                                                  }
                                                },
                                                plugins: {
                                                  legend: {
                                                    position: 'bottom' as const,
                                                    display: true
                                                  },
                                                  title: {
                                                    display: false,
                                                    text: ``,
                                                  },
                                                  zoom: {
                                                    pan: {
                                                      enabled: false,
                                                      onPan: this.onPan
                                                    },
                                                    zoom: {
                                                      wheel: {
                                                        enabled: false
                                                      }
                                                    }
                                                    // limits: {
                                                    //   y: { min: 0, max: 9 },
                                                    // },
                                                  },
                                                  tooltip: {
                                                    ...rvTooltipStyle,
                                                    callbacks: {
                                                        // tslint:disable-next-line: no-any
                                                        label: function (context: any) {
                                                            const { 
                                                                dataIndex, 
                                                                //   label, 
                                                                formattedValue,
                                                                dataset,
                                                                datasetIndex
                                                            } = context;

                                                            const currentValue = convertStringNumberToNumber(formattedValue);

                                                            let enquiryCount = lastPeriodCount[dataIndex];

                                                            if (datasetIndex === 0) {
                                                                enquiryCount = previousPeriodCount[dataIndex];
                                                            }

                                                            const enquiries = enquiryCount !== '1' ? 'enquiries' : 'enquiry';
                                                            
                                                            return `${dataset.label}: ${enquiryCount} ${enquiries}, ${formatNumber(currentValue)}%`;
                                                        },
                                                    }
                                                  }
                                                },
                                            }}
                                        />
                                    </BarContainer>
                                    {
                                        groupedByCount > 10 ?
                                            (<ChartLimitNote>The top 10 {groupBy} are shown</ChartLimitNote>) : undefined
                                    }
                                    <ProcessEnquiryWrapper>
                                        <span>Minimum {t('enquiries')} processed</span>
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            inputProps={{ min: 0 }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            defaultValue={this.state.minimumEnquiries}
                                            onChange={event => {
                                                const { value } = event.target;
                                                // tslint:disable-next-line:radix
                                                this.setState({ minimumEnquiries: parseInt(value) });
                                              }}
                                        />
                                    </ProcessEnquiryWrapper>
                                </BarWrapper>
                            );
                        }

                        return (
                            <LoadWrapper className="load-wrapper">
                                <RvLoader size="small" />
                            </LoadWrapper>
                        );
                    }}
                </Query>
            </CardWrapper>                
        );
    }

    private onCloseChart() {
        if (this.props.onCloseChart) {
            return this.props.onCloseChart(`IsLeadConversionInLast${formatPeriodNoSpace(this.props.period)}ByLawyerChartOpen`);
        }
    }

    // tslint:disable-next-line: no-any
    private handlePopoverOpen(event: any) {
        this.setAnchorEl(event.currentTarget);
    }

    private handlePopoverClose = () => {
        this.setAnchorEl(null);
    }

    // tslint:disable-next-line: no-any
    private setAnchorEl(anchorElValue: any) {
        this.setState({
            anchorEl: anchorElValue,
            open: Boolean(anchorElValue)
        });
    }

    private onPan = (context: { chart: Chart }) => {
        this.chartRef.current.options.scales.x.min = 0;
        this.chartRef.current.update();
    }

    private onHover(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    }
}

// tslint:disable-next-line: no-any
export default withTranslation()(withStyles(styles as any, { withTheme: true })(LeadConversationInLastByPeriodChart as any) as any);

const ChartData = gql`query LeadsConversionInLastPeriodChartData ($entityType: Int, $entityGuid: String, $period: LeadsPeriod, $minimumEnquiries: Int) {
    statistics {
      lead {
        leadsConversionInLastPeriod (entityType: $entityType, entityGuid: $entityGuid, period: $period, minimumEnquiries: $minimumEnquiries) {
          leadsPeriodTotalCount {
            lastPeriodTotalRate
            previousPeriodTotalRate
            lastPeriodTotalCount
            previousPeriodTotalCount
          }
          groupedLeadsForLastPeriod {
            groupedBy
            lastPeriodRate
            previousPeriodRate
            lastPeriodCount
            previousPeriodCount
          }
          groupedByCount
        }
      }
    }
}`;